import layout from '@/layout/index.vue'

export default {
  path: '/display',
  component: layout,
  redirect: '/display/sale',
  name: 'displaySales',
  meta: {
    title: '展示',
    icon: 'goods'
  },
  children: [
    {
      path: '/display/sale',
      name: 'displaySale',
      component: () => import('@/views/display/sale/index.vue'),
      meta: {
        title: '实收金额',
        icon: 'goods'
      }
    },
    {
      path: '/display/cost',
      name: 'displayCost',
      component: () => import('@/views/display/cost/index.vue'),
      meta: {
        title: '成本&利润',
        icon: 'goods'
      }
    },
    {
      path: '/display/profit',
      name: 'displayProfit',
      component: () => import('@/views/display/profit/index.vue'),
      meta: {
        title: '剩余利润',
        icon: 'goods'
      }
    },
    {
      path: '/display/prepare',
      name: 'displayPrepare',
      component: () => import('@/views/display/prepare/index.vue'),
      meta: {
        title: '开店准备',
        icon: 'goods'
      }
    },
    {
      path: '/display/cal',
      name: 'displayCal',
      component: () => import('@/views/display/cal/index.vue'),
      meta: {
        title: '盈利计算器',
        icon: 'goods'
      }
    }
  ]
}
